/* ==========================================================================
   SP-PDP-NEU — Test-Produktseite (sections/sp-pdp-neu.liquid) · 10.10.2026: Vorbefüllung für Nachbestellungen (SP-NACHBESTELLEN)
   Technik/Positionen/Aufpreise: aus dem Aris-Optionssatz des Produkts (SP-ARIS, 02.10.2026), sonst feste Werte
   Schritte: Farben → Größen & Mengen → Logos & Veredelung (bis zu 2 Logos)
   Warenkorb: /cart/add.js (JSON, mit Logo-Datei als FormData/multipart)
   ========================================================================== */
(function () {
  'use strict';

  var POSITIONS = [
    { key: 'links',    label: 'Brust links',     side: 'front', mark: [222, 112, 56, 40] },
    { key: 'mitte',    label: 'Brust Mitte',     side: 'front', mark: [150, 118, 100, 62] },
    { key: 'rechts',   label: 'Brust rechts',    side: 'front', mark: [122, 112, 56, 40] },
    { key: 'schulter', label: 'Schulterblatt',   side: 'back',  mark: [140, 64, 120, 50], charge: 'schulter', druckOnly: true, max: 'max. 30 × 15 cm' },
    { key: 'ruecken',  label: 'Rücken komplett', side: 'back',  mark: [120, 110, 160, 190], charge: 'ruecken', druckOnly: true, max: 'max. 30 × 40 cm' }
  ];
  // Positionen, die sich auf dem Shirt überschneiden
  var CONFLICT = { links: ['mitte', 'a-brust-komplett'], rechts: ['mitte', 'a-brust-komplett'], mitte: ['links', 'rechts', 'a-brust-komplett'],
    'a-brust-komplett': ['links', 'rechts', 'mitte'], schulter: ['ruecken'], ruecken: ['schulter'] };
  var MAX_LOGOS = 2;
  // SP-AERMEL (2026-10-09): Standardbreite je Position (wie in der Logo-Vorschau). Wechselt der Kunde die Position,
  // springt die Breite auf diesen Wert – solange er sie nicht selbst eingetragen hat.
  var DEFW = { links: 8, rechts: 8, mitte: 20, 'a-brust-komplett': 28, schulter: 25, ruecken: 28, 'a-nacken': 6, 'a-aermel-links': 8, 'a-aermel-rechts': 8, 'a-krempe-vorne': 8 };
  var MARK_COLORS = ['#78E6D0', '#FFC857'];
  /* SP-BRUSTMITTE (18.10.2026, Inhaber): zusätzliche Vorne-Positionen im Schritt „Logos & Veredelung“.
     T-Shirts und Sweatshirts: „Brust Mitte“ + „Brust komplett“; Hoodies und Zip-Hoodies: nur „Brust Mitte“.
     Erkennung über die Produktart (data-splp-data.ptype, DE und EN). Nur wenn der Aris-Optionssatz die Position noch nicht hat
     (manche Sweatshirts/Hoodies haben sie schon mit eigener Aufpreis-Variante – dann gilt Aris).
     Aufpreis: dieselbe Aufpreis-Variante (id + Preis) wie „Schulterblatt“ (Brust Mitte, max. 30 × 15 cm) bzw.
     „Rücken komplett“ (Brust komplett, max. 30 × 40 cm), nur Digitaldruck. Fehlt die Variante, kommt die Position nicht dazu.
     Warenkorb: Aufpreis-Zeile mit Property „Position“ (echte Position, weil der Variantenname „Schulterblatt …“ heißt).
     Foto-Vorschau: Brust komplett über el.spnPosDefs; Brust Mitte über positions.mitte (30 × 15, Breite 25) in sections/sp-logo-preview.liquid. */
  var FRONT_TS = /^\s*(t-?shirts?|sweatshirts?|sweatshirts mit rundhalsausschnitt|crew[ -]neck sweatshirts?)\s*$/i;
  var FRONT_HO = /^\s*(hoodies?|zip[ -]?hoodies?|hoodie[ -]sweatshirts?)\s*$/i;
  var FRONT_ADD = [
    { key: 'mitte', label: 'Brust Mitte', from: 'schulter', area: [30, 15], max: 'max. 30 × 15 cm', ts: 1, ho: 1 },
    { key: 'a-brust-komplett', label: 'Brust komplett', from: 'ruecken', area: [30, 40], max: 'max. 30 × 40 cm', ts: 1, ho: 0 }
  ];
  var EXTRA_MARK = { 'a-brust-komplett': [120, 100, 160, 190] }; // Schema-Shirt vorne (Rücken komplett gespiegelt)
  /* SP-CAP (17.10.2026, Canvas Board 249 „Caps: Logo live auf dem Foto“): Foto-Vorschau auch für Caps.
     Erkennung (applyAris): Produktart „Caps“ (data-splp-data.ptype aus sections/sp-logo-preview.liquid) ODER – bei jeder
     anderen Produktart außer Mützen/Hüten/Taschen usw. (CAP_NOT) – ein Optionssatz, der nur aus Cap-Positionen besteht
     (Vorne Mitte + Vorne links/rechts, optional Hinten). Erkannt wird am deutschen Aris-Wert bzw. Schlüssel (a-vorne-mitte …),
     englische Namen sind als Ersatz mit drin. Mützen („Krempe vorne“) bleiben bei SP-MUETZE.
     Je Cap-Position: Druckfläche in cm (Aris-Wert, höchstens CAP_MAX), Startbreite CAP_W. Lage/Maßstab im Foto:
     assets/sp-logo-preview.js (SP-CAP, capGeo/capAt). */
  var CAP_TYPES = /^\s*(caps?|base\s*caps?|baseball\s*caps?|basecaps?|kappen?|schirmm(ü|ue)tzen?|trucker\s*caps?|snapbacks?)\s*$/i;
  var CAP_NOT = /m(ü|ue)tze|beanie|h(ü|ue)te?\b|hats?\b|tasche|beutel|bags?\b|rucksack|backpack|schirm|umbrella|schal|scarf|stirnband|bandana|shirt|hood|sweat|jacke|jacket|polo|weste|sch(ü|ue)rze|apron/i;
  var CAP_AREA = { mitte: [10, 6], links: [5, 5], rechts: [5, 5], hinten: [8.5, 5] }; // ohne Angabe im Optionssatz
  var CAP_MAX = { mitte: [10, 7], links: [5, 5], rechts: [5, 5], hinten: [8.5, 5] };  // mehr passt auf Frontpanel/Seitenteil/Hinterteil nicht
  var CAP_FIX = { hinten: 1 };                                                       // Inhaber 17.10.2026: Cap hinten immer 8,5 × 5 cm, auch wenn Aris weniger sagt
  var CAP_W = { mitte: 8, links: 4, rechts: 4, hinten: 6 };                          // Startbreite in cm
  var CAP_PH = { mitte: 0.6, links: 0.8, rechts: 0.8, hinten: 0.5 };                 // Platzhalter Höhe/Breite
  function capKind(l) {
    var t = String(l || '').trim().toLowerCase().replace(/\s+/g, ' ');
    if (/^(a-)?vorne[ -](mitte|mittig)$|^front (centre|center|middle)$|^(centre|center) front$/.test(t)) return 'mitte';
    if (/^(a-)?vorne[ -]links$|^front left$|^left front$/.test(t)) return 'links';
    if (/^(a-)?vorne[ -]rechts$|^front right$|^right front$/.test(t)) return 'rechts';
    if (/^(a-)?hinten([ -](mitte|mittig))?$|^(back|rear)( (centre|center))?$/.test(t)) return 'hinten';
    return '';
  }
  function capPtype() {
    try { return String((JSON.parse(document.querySelector('[data-splp-data]').textContent) || {}).ptype || ''); } catch (e) { return ''; }
  }

  function eur(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function genId() {
    return 'sp' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  function init(el) {
    if (el.dataset.spnReady) return;
    el.dataset.spnReady = '1';

    var data;
    try { data = JSON.parse(el.querySelector('[data-spn-data]').textContent); } catch (e) { console.error('[spn] data', e); return; }

    var $ = function (s) { return el.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(el.querySelectorAll(s)); };

    var colorMap = {};
    data.colors.forEach(function (c) { colorMap[c.name] = c; });
    var vmap = {};
    data.variants.forEach(function (v) { vmap[v.color + '|' + v.size] = v; });

    var state = {
      sel: data.initialColor ? [data.initialColor] : [],
      active: data.initialColor || null,
      qty: {},
      logos: [{ fin: 'druck', pos: 'links', width: '8', file: null }],
      later: false,
      busy: false
    };
    // SP-LOGO-PREVIEW (2026-09-27): Zustand + Änderungs-Event für assets/sp-logo-preview.js
    el.spnState = state;
    function emit() { try { el.dispatchEvent(new CustomEvent('spn:change', { detail: state })); } catch (e) {} }

    /* ---------------- Galerie ---------------- */
    var stage = $('[data-spn-stage-img]');
    function showColor(name) {
      var c = colorMap[name];
      var dot = $('[data-spn-stage-dot]');
      var lbl = $('[data-spn-stage-color]');
      if (lbl) lbl.textContent = name || '';
      if (dot) {
        dot.style.background = (c && c.hex) ? c.hex : '#ccc';
        dot.style.backgroundImage = (c && !c.hex && c.image) ? 'url("' + c.image + '")' : '';
        dot.style.backgroundSize = 'cover';
      }
      if (stage && c && c.image && stage.getAttribute('src') !== c.image) {
        stage.classList.add('is-loading');
        stage.removeAttribute('srcset');
        stage.onload = function () { stage.classList.remove('is-loading'); };
        stage.src = c.image;
        stage.alt = data.title + ' in ' + name;
      }
      emit();
    }
    $$('[data-spn-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!stage) return;
        stage.removeAttribute('srcset');
        stage.src = b.getAttribute('data-src');
        $$('[data-spn-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });

    /* ---------------- Schritt 1: Farben ---------------- */
    function syncSwatches() {
      $$('[data-spn-sw]').forEach(function (b) {
        var n = b.getAttribute('data-spn-sw');
        b.setAttribute('aria-pressed', state.sel.indexOf(n) >= 0 ? 'true' : 'false');
        b.classList.toggle('is-active', n === state.active);
      });
      var sc = $('[data-spn-selcount]');
      if (sc) sc.textContent = state.sel.length;
    }
    $$('[data-spn-sw]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-spn-sw');
        if (state.sel.indexOf(n) < 0) { state.sel.push(n); buildRows(); }
        setActive(n);
        var row = el.querySelector('[data-spn-row="' + cssEsc(n) + '"] input:not([disabled])');
        if (row && window.matchMedia('(min-width: 850px)').matches) row.focus({ preventScroll: true });
      });
    });
    function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/"/g, '\\"'); }
    function setActive(n) {
      state.active = n;
      syncSwatches();
      $$('[data-spn-row]').forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-spn-row') === n); });
      showColor(n);
    }

    /* ---------------- Schritt 2: Zeilen ---------------- */
    var rowsBox = $('[data-spn-rows]');
    function buildRows() {
      rowsBox.innerHTML = '';
      state.sel.forEach(function (name) {
        var c = colorMap[name] || {};
        var row = document.createElement('div');
        row.className = 'spn-row' + (name === state.active ? ' is-active' : '');
        row.setAttribute('data-spn-row', name);

        var head = document.createElement('div');
        head.className = 'spn-row__head';
        var dot = document.createElement('span');
        dot.className = 'spn-row__dot';
        if (c.hex) dot.style.background = c.hex; else if (c.image) dot.style.backgroundImage = 'url("' + c.image + '")';
        var nm = document.createElement('button');
        nm.type = 'button'; nm.className = 'spn-row__name'; nm.textContent = name;
        nm.addEventListener('click', function () { setActive(name); });
        var sum = document.createElement('span');
        sum.className = 'spn-row__sum'; sum.setAttribute('data-spn-rowsum', '');
        var x = document.createElement('button');
        x.type = 'button'; x.className = 'spn-row__x'; x.setAttribute('aria-label', name + ' entfernen');
        x.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        x.addEventListener('click', function () {
          state.sel = state.sel.filter(function (s) { return s !== name; });
          delete state.qty[name];
          if (state.active === name) state.active = state.sel[0] || null;
          buildRows(); syncSwatches(); if (state.active) showColor(state.active); update();
        });
        head.appendChild(dot); head.appendChild(nm); head.appendChild(sum); head.appendChild(x);

        var cells = document.createElement('div');
        cells.className = 'spn-row__cells';
        data.sizes.forEach(function (s) {
          var v = vmap[name + '|' + s];
          var wrap = document.createElement('span');
          wrap.className = 'spn-cell'; wrap.setAttribute('data-size', s);
          var inp = document.createElement('input');
          inp.className = 'spn-qty'; inp.type = 'text'; inp.inputMode = 'numeric'; inp.autocomplete = 'off';
          inp.setAttribute('aria-label', 'Menge ' + name + ' ' + s);
          inp.placeholder = '0';
          if (!v || !v.available) {
            inp.disabled = true; inp.placeholder = '–'; inp.title = 'Nicht verfügbar';
          } else {
            var cur = (state.qty[name] && state.qty[name][s]) || 0;
            inp.value = cur ? String(cur) : '';
            inp.addEventListener('focus', function () { if (state.active !== name) setActive(name); inp.select(); });
            inp.addEventListener('input', function () {
              var n = parseInt(inp.value.replace(/\D/g, ''), 10);
              if (isNaN(n)) n = 0; if (n > 9999) n = 9999;
              if (inp.value !== '' && String(n) !== inp.value) inp.value = n ? String(n) : '';
              state.qty[name] = state.qty[name] || {};
              state.qty[name][s] = n;
              update();
            });
          }
          wrap.appendChild(inp);
          cells.appendChild(wrap);
        });
        row.appendChild(head); row.appendChild(cells);
        rowsBox.appendChild(row);
      });
      $('[data-spn-empty]').hidden = state.sel.length > 0;
      update();
    }

    var copyBtn = $('[data-spn-copymix]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var src = state.qty[state.active] || {};
      state.sel.forEach(function (n) {
        state.qty[n] = {};
        Object.keys(src).forEach(function (s) {
          var v = vmap[n + '|' + s];
          if (v && v.available) state.qty[n][s] = src[s];
        });
      });
      buildRows();
    });

    /* ---------------- Schritt 3: Logos & Veredelung ---------------- */
    // SP-ARIS (2026-10-02): Technik, Positionen und Aufpreise je Logo kommen aus dem Aris-Optionssatz des Produkts
    // (.app-avis-product-options-block, wird von Aris per JS gerendert). Bis Aris fertig ist – oder ohne Aris –
    // gelten die festen Werte (POSITIONS + Section-Einstellungen charges/charges2).
    var logosBox = $('[data-spn-logos]'), addBtn = $('[data-spn-addlogo]');
    var laterChk = $('[data-spn-latercheck]'), laterTxt = $('[data-spn-later]');
    var TECH = { druck: ['Digitaldruck', 'Volle Farbigkeit, Verläufe'], stick: ['Stick', 'Bis 3 Garnfarben, edel'] };
    var SIDES = [['front', 'Vorne'], ['back', 'Hinten'], ['sleeve', 'Ärmel']];
    var NOCHARGE = { id: 0, price: 0 };
    var maxLogos = MAX_LOGOS;
    function chargesFor(i) { return i === 0 ? data.charges : (data.charges2 || data.charges); }
    function defaultModel() {
      return [0, 1].map(function (i) {
        var ch = chargesFor(i);
        return {
          tech: { druck: ch.druck, stick: ch.stick },
          pos: POSITIONS.map(function (p) {
            var by = { druck: p.charge && ch[p.charge] ? ch[p.charge] : NOCHARGE };
            if (!p.druckOnly) by.stick = NOCHARGE;
            return { key: p.key, label: p.label, side: p.side, mark: p.mark, max: p.max || '', by: by };
          })
        };
      });
    }
    var M = defaultModel();
    function mdl(i) { return M[i] || M[0]; }
    function findPos(key, i) { var L = mdl(i).pos; for (var k = 0; k < L.length; k++) if (L[k].key === key) return L[k]; return null; }
    function posOf(key, i) { return findPos(key, i) || mdl(i).pos[0]; }
    function techOf(lg, i) { return mdl(i).tech[lg.fin] || NOCHARGE; }
    function allowed(p, fin) { return !!(p && p.by && p.by[fin]); }
    function posCharge(p, fin) { return (p && p.by && p.by[fin]) || NOCHARGE; }
    function logoCost(lg, i) { return techOf(lg, i).price + posCharge(posOf(lg.pos, i), lg.fin).price; }
    function finLabel(f) { return (TECH[f] || [f])[0]; }
    function firstFin(i) { var t = mdl(i).tech; return t.druck ? 'druck' : (t.stick ? 'stick' : 'druck'); }
    function firstPos(i, fin) {
      var L = mdl(i).pos;
      for (var k = 0; k < L.length; k++) if (allowed(L[k], fin)) return L[k].key;
      return L[0] ? L[0].key : null;
    }

    // Überschneidungen: gleiche Position; feste Paare (CONFLICT); „Mitte/mittig“ gegen links/rechts derselben Zone
    // (gleiches erstes Wort, z. B. „Brust …“, „Vorne …“); „groß/komplett“ gegen dieselbe Zone bzw. den ganzen Rücken.
    function firstWord(t) { return String(t || '').trim().split(/\s+/)[0].toLowerCase(); }
    function isBig(p) { return /gro(ß|ss)|komplett/i.test(p.label); }
    function clash(a, b) {
      if (!a || !b) return false;
      if (a.key === b.key) return true;
      if ((CONFLICT[a.key] || []).indexOf(b.key) >= 0) return true;
      if (a.side !== b.side || a.side === 'sleeve') return false;
      if (/nacken/i.test(a.label) || /nacken/i.test(b.label)) return false;
      var same = firstWord(a.label) === firstWord(b.label);
      if (isBig(a) || isBig(b)) return same || a.side === 'back';
      return same && (/mitt/i.test(a.label) || /mitt/i.test(b.label));
    }
    function blocked(key, i) {
      var p = findPos(key, i), hit = false;
      // nur eine Position im Optionssatz (z. B. „Mütze“): Aris erlaubt dort ein zweites Logo
      if (!p || mdl(i).pos.length < 2) return false;
      state.logos.forEach(function (o, j) { if (j !== i && clash(findPos(o.pos, j), p)) hit = true; });
      return hit;
    }
    function firstFree(i, fin) {
      var pref = ['ruecken', 'rechts', 'links', 'schulter', 'mitte'];
      var rank = function (p) { var r = pref.indexOf(p.key); return r >= 0 ? r : (p.side === 'back' ? 5 : (p.side === 'front' ? 6 : 7)); };
      var L = mdl(i).pos.filter(function (p) { return allowed(p, fin); });
      L = L.map(function (p, k) { return { p: p, k: k }; }).sort(function (a, b) { return (rank(a.p) - rank(b.p)) || (a.k - b.k); });
      for (var k = 0; k < L.length; k++) if (!blocked(L[k].p.key, i)) return L[k].p.key;
      return null;
    }
    function el_(tag, cls, html) { var d = document.createElement(tag); if (cls) d.className = cls; if (html != null) d.innerHTML = html; return d; }
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    /* ---- Aris-Optionssatz lesen ---- */
    var KNOWN = [[/^brust\s+links$/i, 'links'], [/^brust\s+rechts$/i, 'rechts'], [/^brust\s+mitt/i, 'mitte'], [/^schulterblatt$/i, 'schulter'], [/^r(ü|ue)cken\s+komplett$/i, 'ruecken']];
    function keyFor(l) {
      for (var k = 0; k < KNOWN.length; k++) if (KNOWN[k][0].test(l)) return KNOWN[k][1];
      return 'a-' + l.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    function sideFor(l) {
      if (/ärmel|aermel/i.test(l)) return 'sleeve';
      return /hinten|r(ü|ue)ck|nacken|schulterblatt/i.test(l) ? 'back' : 'front';
    }
    function markFor(key) { for (var k = 0; k < POSITIONS.length; k++) if (POSITIONS[k].key === key) return POSITIONS[k].mark; return EXTRA_MARK[key] || null; }
    // SP-BRUSTMITTE: Vorne-Positionen ergänzen (siehe FRONT_ADD oben)
    function frontAdd(mod) {
      var t = capPtype(), ts = FRONT_TS.test(t), ho = !ts && FRONT_HO.test(t);
      if (!ts && !ho) return;
      DEFW.mitte = DEFW.schulter; // Brust Mitte wie Schulterblatt (25 cm), auch wenn Aris sie schon hat
      mod.forEach(function (m) {
        if (!m.tech || !m.tech.druck) return;
        var idx = {}, last = -1;
        m.pos.forEach(function (p, k) { idx[p.key] = p; if (p.side === 'front') last = k; });
        FRONT_ADD.forEach(function (a) {
          if (!(ts ? a.ts : a.ho) || idx[a.key]) return;
          var src = idx[a.from], c = src && src.by && src.by.druck;
          if (!c || !c.id || !c.price) { console.warn('[spn] ' + a.label + ' nicht ergänzt: keine Aufpreis-Variante bei „' + (src ? src.label : a.from) + '“'); return; }
          var p = { key: a.key, label: a.label, side: 'front', mark: markFor(a.key), max: a.max, area: a.area.slice(), by: { druck: { id: c.id, price: c.price } }, via: a.from };
          m.pos.splice(++last, 0, p); idx[a.key] = p;
        });
      });
    }
    function splitLabel(v) {
      var t = String(v || '').replace(/\s*Aufpreis\s*$/i, '').trim(), max = '', area = null;
      var i = t.search(/\(?\s*max\.?\s*\d/i);
      if (i > 0) {
        max = t.slice(i).replace(/[()]/g, '').trim(); t = t.slice(0, i).trim();
        var mm = /(\d+(?:[.,]\d+)?)\s*(?:cm)?\s*[x×]\s*(\d+(?:[.,]\d+)?)/i.exec(max);
        if (mm) area = [parseFloat(mm[1].replace(',', '.')), parseFloat(mm[2].replace(',', '.'))];
        max = max.replace(/(\d)\s*(cm)?\s*[x×]\s*(?=\d)/gi, function (a, d, cm) { return d + (cm ? ' cm' : '') + ' × '; }).replace(/(\d)cm/g, '$1 cm');
      }
      return { label: t, max: max, area: area };
    }
    function int(v) { var n = parseInt(v, 10); return isFinite(n) ? n : 0; }
    // App-Block im Template; ohne App-Block hängt Aris seine Optionen selbst irgendwo ein (avpoptions-container__v2)
    function arisBlock() { return document.querySelector('.app-avis-product-options-block') || document.querySelector('.avpoptions-container__v2'); }
    function arisRead() {
      var b = arisBlock();
      if (!b) return null;
      var L = {}, cur = {}, lastN = -1;
      Array.prototype.forEach.call(b.querySelectorAll('.avp-option'), function (g) {
        // Technik als Radio oder Checkbox (z. B. Warnwesten), Positionen als Radio
        var rs = g.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        if (!rs.length) return;
        var fn = (rs[0].getAttribute('field-name') || rs[0].name || '').trim();
        var m = /^(\d+)\.\s*Logo\b(.*)$/i.exec(fn), n, rest;
        if (m) { n = +m[1] - 1; rest = m[2]; }
        else if (/^position\b/i.test(fn) && lastN >= 0) { n = lastN; rest = fn; } // z. B. Regenschirme: Gruppe heißt nur „Position“
        else return;
        if (n < 0 || n > 1) return;
        var lo = L[n] = L[n] || { tech: {}, pos: [], idx: {} };
        if (!/position/i.test(rest)) {
          // Technik-Gruppe; eine schon bekannte Technik (zweiter Optionssatz am selben Produkt) wird ignoriert
          var added = [];
          Array.prototype.forEach.call(rs, function (r) {
            var k = /stick/i.test(r.value) ? 'stick' : (/druck/i.test(r.value) ? 'druck' : '');
            var id = int(r.getAttribute('data-variant-id'));
            if (!k || lo.tech[k] || !id) return;
            lo.tech[k] = { id: id, price: int(r.getAttribute('data-variant-price')) };
            added.push(k);
          });
          cur[n] = added;
          lastN = n;
          return;
        }
        // Positions-Gruppe gehört zur Technik davor; „(Digitaldruck)“ / „(Stick)“ im Namen grenzt ein
        var want = /\(\s*(digital)?druck/i.test(rest) ? 'druck' : (/\(\s*stick/i.test(rest) ? 'stick' : '');
        var ks = (cur[n] || []).filter(function (k) { return !want || k === want; });
        if (!ks.length) return;
        Array.prototype.forEach.call(rs, function (r) {
          var x = splitLabel(r.value);
          if (!x.label) return;
          var price = int(r.getAttribute('data-variant-price')), id = int(r.getAttribute('data-variant-id'));
          if (price && !id) { console.warn('[spn] Aris-Position ohne Aufpreis-Variante übersprungen:', r.value); return; }
          var key = keyFor(x.label), p = lo.idx[key];
          if (!p) { p = lo.idx[key] = { key: key, label: x.label, side: sideFor(x.label), mark: markFor(key), max: x.max, area: x.area, by: {} }; lo.pos.push(p); }
          if (!p.max && x.max) { p.max = x.max; p.area = x.area; }
          ks.forEach(function (k) { if (!p.by[k]) p.by[k] = price ? { id: id, price: price } : NOCHARGE; });
        });
      });
      var out = [];
      for (var n = 0; n < 2; n++) {
        var lo = L[n];
        if (!lo || !lo.pos.length || !(lo.tech.druck || lo.tech.stick)) break;
        out.push({ tech: lo.tech, pos: lo.pos });
      }
      return out.length ? out : null;
    }
    /* ---- SP-NACHBESTELLEN (10.10.2026): Vorbefüllung aus /pages/nachbestellen (sessionStorage spNbPrefill) ----
       Übernimmt Farben, Mengen (nur lieferbare Varianten), Veredelung, Position, Breite und die Logo-Datei als Link.
       Aufpreise rechnet der Konfigurator wie immer selbst (heutige Preise). Nach dem Warenkorb: spNbDone + Rücklink. */
    var nbOnce = false, nbInfo = null, NB_EN = /^en/i.test(document.documentElement.lang || '');
    function nbT(de, en) { return NB_EN ? en : de; }
    function nbPrefill() {
      if (nbOnce) return; nbOnce = true;
      var p = null;
      try { p = JSON.parse(sessionStorage.getItem('spNbPrefill') || 'null'); } catch (e) { p = null; }
      if (!p || p.v !== 1 || !p.handle || Date.now() - (p.ts || 0) > 3600000) return;
      if (decodeURIComponent(location.pathname).indexOf('/products/' + p.handle) < 0) return;
      try { sessionStorage.removeItem('spNbPrefill'); } catch (e) {}
      var skipped = 0, notes = [];
      if (p.qty) {
        var sel = [], qty = {};
        Object.keys(p.qty).forEach(function (c) {
          Object.keys(p.qty[c]).forEach(function (s) {
            var v = vmap[c + '|' + s], k = +p.qty[c][s] || 0;
            if (!k) return;
            if (!v || !v.available) { skipped += k; return; }
            if (sel.indexOf(c) < 0) sel.push(c);
            qty[c] = qty[c] || {}; qty[c][s] = k;
          });
        });
        if (sel.length) { state.sel = sel; state.qty = qty; state.active = sel[0]; }
      }
      var logos = [];
      (p.logos || []).slice(0, maxLogos).forEach(function (x, i) {
        var m = mdl(i);
        var fin = (x.fin && m.tech[x.fin]) ? x.fin : firstFin(i);
        if (x.fin && fin !== x.fin) notes.push(nbT('Logo ' + (i + 1) + ': ' + finLabel(x.fin) + ' gibt es für diesen Artikel nicht, wir haben ' + finLabel(fin) + ' gewählt.', 'Logo ' + (i + 1) + ': ' + finLabel(x.fin) + ' isn’t available for this item, we chose ' + finLabel(fin) + '.'));
        var lab = splitLabel(x.pos || '').label, pos = lab ? findPos(keyFor(lab), i) : null;
        if (!pos && lab) m.pos.forEach(function (q) { if (!pos && q.label.toLowerCase() === lab.toLowerCase()) pos = q; });
        var key = (pos && allowed(pos, fin)) ? pos.key : firstPos(i, fin);
        if (lab && (!pos || !allowed(pos, fin))) notes.push(nbT('Logo ' + (i + 1) + ': Position „' + lab + '“ gibt es hier nicht – bitte wählen.', 'Logo ' + (i + 1) + ': position “' + lab + '” isn’t available here – please choose one.'));
        var w = String(x.width || '').replace(/[^0-9.,]/g, '');
        logos.push({ fin: fin, pos: key, width: w || String(DEFW[key] || 8), wSet: !!w, file: null, fileUrl: x.fileUrl || '', fileName: x.fileName || '' });
        (x.notes || []).forEach(function (t) { notes.push('Logo ' + (i + 1) + ': ' + t); });
      });
      if (logos.length) {
        state.logos = logos;
        state.logos.forEach(function (lg, i) { if (i > 0 && blocked(lg.pos, i)) { var f = firstFree(i, lg.fin); if (f) lg.pos = f; } });
      }
      state.reorder = p.order || '';
      nbInfo = p;
      syncSwatches(); buildRows(); if (state.active) setActive(state.active); buildLogos(); update();
      nbBanner(p, skipped, notes);
    }
    function nbBanner(p, skipped, notes) {
      if (!document.getElementById('spn-nb-css')) {
        var css = document.createElement('style'); css.id = 'spn-nb-css';
        css.textContent = '.spn-nbnote{background:#E6F8F2;border-radius:12px;padding:16px;margin:0 0 16px;display:flex;flex-direction:column;gap:8px;font-size:16px;line-height:24px;color:#111111}' +
          '.spn-nbnote__t{font-weight:700;letter-spacing:.04em;text-transform:uppercase;line-height:20px}' +
          '.spn-nbnote a{color:#111111;text-decoration:underline;text-decoration-color:#78E6D0;text-decoration-thickness:2px;text-underline-offset:4px}.spn-nbnote a:hover{color:#0B6B5A}';
        document.head.appendChild(css);
      }
      var d = el_('div', 'spn-nbnote');
      var h = '<span class="spn-nbnote__t">' + esc(nbT('Nachbestellung von ', 'Reorder of ') + (p.order || '')) + '</span>';
      h += '<span>' + esc(p.qty
        ? nbT('Farben, Mengen und Logos sind übernommen. Prüf alles und leg es in den Warenkorb.', 'Colours, quantities and logos are carried over. Check everything and add it to your cart.')
        : nbT('Deine Logos sind übernommen. Wähl Farben und Mengen – letztes Mal: ', 'Your logos are carried over. Choose colours and quantities – last time: ') + (p.prev || '')) + '</span>';
      if (skipped) h += '<span>' + esc(nbT(skipped + ' Stück in Größen, die gerade nicht lieferbar sind, haben wir weggelassen.', 'We left out ' + skipped + ' pcs in sizes that are currently unavailable.')) + '</span>';
      notes.forEach(function (t) { h += '<span>' + esc(t) + '</span>'; });
      if (p.back) h += '<a href="' + esc(p.back) + '">← ' + esc(nbT('Zurück zur Bestellung', 'Back to the order')) + '</a>';
      d.innerHTML = h;
      var first = el.querySelector('.spn-step');
      if (first && first.parentNode) first.parentNode.insertBefore(d, first); else el.insertBefore(d, el.firstChild);
    }
    function nbAfter() {
      if (!state.reorder || !nbInfo) return '';
      try {
        var D = JSON.parse(sessionStorage.getItem('spNbDone') || '{}') || {};
        var i = +String(nbInfo.key || '').split('#').pop();
        D[nbInfo.order] = D[nbInfo.order] || [];
        if (!isNaN(i) && D[nbInfo.order].indexOf(i) < 0) D[nbInfo.order].push(i);
        sessionStorage.setItem('spNbDone', JSON.stringify(D));
      } catch (e) {}
      return nbInfo.back ? ' · <a href="' + esc(nbInfo.back) + '">' + esc(nbT('Weiter mit Bestellung ', 'Continue with order ') + nbInfo.order) + ' →</a>' : '';
    }

    function applyAris(mod) {
      logosBox.style.opacity = ''; logosBox.style.pointerEvents = '';
      if (!mod) { nbPrefill(); return; }
      frontAdd(mod); // SP-BRUSTMITTE
      M = mod;
      maxLogos = Math.min(MAX_LOGOS, M.length);
      state.logos = state.logos.slice(0, maxLogos);
      state.logos.forEach(function (lg, i) {
        if (!mdl(i).tech[lg.fin]) lg.fin = firstFin(i);
        var p = findPos(lg.pos, i);
        if (!p || !allowed(p, lg.fin) || blocked(lg.pos, i)) lg.pos = (i > 0 && firstFree(i, lg.fin)) || firstPos(i, lg.fin);
      });
      // Foto-Vorschau nur für Oberteile (Positionen wie Brust/Rücken); sonst ausblenden statt falsch zeigen
      var shirt = false, defs = {};
      M.forEach(function (m) {
        m.pos.forEach(function (p) {
          if (p.mark) shirt = true;
          if (/^nacken$/i.test(p.label)) defs[p.key] = { label: p.label, side: 'back', fx: 0, fy: 0.03, min: 0, area: p.area || [10, 10], w: 6, ph: 1 };
          // SP-MUETZE (12.10.2026): „Krempe vorne“ (Mützen) – Vorschau auf der Krempe, siehe assets/sp-logo-preview.js hatGeo()
          if (/krempe/i.test(p.label)) { defs[p.key] = { label: p.label, side: 'front', hat: 1, fx: 0, fy: 0, min: 0, area: p.area || [11, 4], w: 8, ph: 0.35 }; shirt = true; }
          // SP-BRUSTMITTE: Brust komplett großflächig vorne (Brust Mitte: POS.mitte + positions.mitte in sections/sp-logo-preview.liquid)
          if (p.key === 'a-brust-komplett' && !defs[p.key]) defs[p.key] = { label: p.label, side: 'front', fx: 0, fy: 0.56, min: 0.44, area: p.area || [30, 40], w: DEFW[p.key], ph: 1 };
        });
      });
      // SP-CAP (17.10.2026): Caps erkennen und ihre Positionen als Vorschau-Zonen anlegen (siehe oben bei CAP_TYPES)
      var ptype = capPtype(), ck = {}, allCap = true, isCap = false;
      M.forEach(function (m) { m.pos.forEach(function (p) { var k = capKind(p.label) || capKind(p.key); if (k) ck[k] = 1; else allCap = false; }); });
      if (CAP_TYPES.test(ptype)) isCap = !!(ck.mitte || ck.links || ck.rechts || ck.hinten);
      else isCap = !CAP_NOT.test(ptype) && allCap && !!ck.mitte && !!(ck.links || ck.rechts);
      if (isCap) {
        M.forEach(function (m) {
          m.pos.forEach(function (p) {
            var k = capKind(p.label) || capKind(p.key);
            if (k && CAP_FIX[k] && defs[p.key] && defs[p.key].cap) { p.area = defs[p.key].area; return; } // gleiche Position in weiterem Optionssatz: Fläche angleichen (sp-logo-place.js liest q.area)
            if (!k || defs[p.key]) return;
            var mx = CAP_MAX[k], a = CAP_FIX[k] ? CAP_AREA[k].slice() : p.area ? [Math.min(p.area[0], mx[0]), Math.min(p.area[1], mx[1])] : CAP_AREA[k].slice();
            if (((p.area && (a[0] !== p.area[0] || a[1] !== p.area[1])) || (CAP_FIX[k] && !p.area)) && p.max) p.max = 'max. ' + String(a[0]).replace('.', ',') + ' × ' + String(a[1]).replace('.', ',') + ' cm';
            p.area = a;
            p.side = k === 'hinten' ? 'back' : 'front';
            defs[p.key] = { label: p.label, side: p.side, cap: k, fx: 0, fy: 0, min: 0, area: a, w: Math.min(CAP_W[k], a[0]), ph: CAP_PH[k] };
          });
        });
        shirt = true;
        // Startbreite an die Cap-Position anpassen, solange der Kunde sie nicht selbst eingetragen hat
        state.logos.forEach(function (lg) { var d = defs[lg.pos]; if (d && d.cap && !lg.wSet && lg.width !== '') lg.width = String(d.w); });
      }
      el.spnCap = isCap;
      el.spnPosDefs = defs;
      el.spnAris = M;
      el.classList.toggle('spn-noprev', !shirt);
      if (noteEl) noteEl.hidden = shirt;
      // Kopf von Schritt 3 („bis zu 2 Logos“) an die Zahl der Logos im Optionssatz anpassen
      var step = logosBox.closest('.spn-step');
      if (step) Array.prototype.forEach.call(step.querySelectorAll('*'), function (x) {
        if (!x.children.length && /^\s*bis zu \d+ Logos\s*$/.test(x.textContent)) x.textContent = maxLogos === 1 ? '1 Logo' : 'bis zu ' + maxLogos + ' Logos';
      });
      setHeadPrice();
      buildLogos(); update();
      nbPrefill();
    }
    var noteEl = null;
    function arisWatch() {
      var hasBlock = !!document.querySelector('.app-avis-product-options-block');
      if (!document.getElementById('spn-aris-css')) {
        var css = document.createElement('style'); css.id = 'spn-aris-css';
        css.textContent = '.spn-noprev .splp-layer,.spn-noprev .splp-toggle,.spn-noprev .splp-bar,.spn-noprev .splp-minis,.spn-noprev .spn-preview{display:none!important}' +
          '.spn-posnote{margin:0 0 12px;font-size:14px;color:#5E656B}';
        document.head.appendChild(css);
      }
      noteEl = el_('p', 'spn-posnote', 'Die genaue Platzierung zeigen wir dir mit der Druckfreigabe, bevor wir produzieren.');
      noteEl.hidden = true;
      logosBox.parentNode.insertBefore(noteEl, logosBox);
      if (hasBlock) { logosBox.style.opacity = '0.35'; logosBox.style.pointerEvents = 'none'; }
      var t0 = Date.now(), last = -1, stable = 0;
      (function tick() {
        var b = arisBlock(), n = b ? b.querySelectorAll('.avp-option input[type="radio"], .avp-option input[type="checkbox"]').length : 0;
        stable = (n && n === last) ? stable + 1 : 0;
        last = n;
        if (n && stable >= 2) return applyAris(arisRead());
        if (Date.now() - t0 > (hasBlock ? 12000 : 8000)) return applyAris(n ? arisRead() : null);
        setTimeout(tick, 250);
      })();
    }

    function buildLogos() {
      logosBox.innerHTML = '';
      state.logos.forEach(function (lg, i) {
        var m = mdl(i), p = posOf(lg.pos, i);
        lg.posLabel = p.label;
        var card = el_('div', 'spn-logo');
        card.style.setProperty('--mk', MARK_COLORS[i]);

        // Kopf
        var head = el_('div', 'spn-logo__head');
        head.appendChild(el_('span', 'spn-logo__no', String(i + 1)));
        var t = el_('div', 'spn-logo__title');
        t.appendChild(el_('strong', '', 'Logo ' + (i + 1)));
        t.appendChild(el_('span', '', esc(p.label) + ' · ' + finLabel(lg.fin)));
        head.appendChild(t);
        head.appendChild(el_('span', 'spn-logo__price', '+' + eur(logoCost(lg, i)) + '<small> / Stk.</small>'));
        if (i > 0) {
          var x = el_('button', 'spn-row__x', '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>');
          x.type = 'button'; x.setAttribute('aria-label', 'Logo ' + (i + 1) + ' entfernen');
          x.addEventListener('click', function () { state.logos.splice(i, 1); buildLogos(); update(); });
          head.appendChild(x);
        }
        card.appendChild(head);

        // Technik
        var r1 = el_('div', 'spn-lrow');
        r1.appendChild(el_('span', 'spn-label', 'Technik'));
        var seg = el_('div', 'spn-seg'); seg.setAttribute('role', 'group'); seg.setAttribute('aria-label', 'Technik Logo ' + (i + 1));
        ['druck', 'stick'].filter(function (f) { return m.tech[f]; }).forEach(function (f) {
          var b = el_('button', 'spn-seg__btn', '<strong>' + TECH[f][0] + ' <em>+' + eur(m.tech[f].price) + '</em></strong><span>' + TECH[f][1] + '</span>');
          b.type = 'button'; b.setAttribute('aria-pressed', lg.fin === f ? 'true' : 'false');
          b.addEventListener('click', function () {
            lg.fin = f;
            if (!allowed(posOf(lg.pos, i), f) || blocked(lg.pos, i)) lg.pos = firstFree(i, f) || firstPos(i, f);
            buildLogos(); update();
          });
          seg.appendChild(b);
        });
        r1.appendChild(seg);
        card.appendChild(r1);

        // Position
        var r2 = el_('div', 'spn-lrow');
        r2.appendChild(el_('span', 'spn-label', 'Position'));
        var grp = el_('div', 'spn-posgrp');
        var sides = SIDES.filter(function (sd) { return m.pos.some(function (q) { return q.side === sd[0]; }); });
        sides.forEach(function (side) {
          var line = el_('div', 'spn-posgrp__line');
          if (sides.length > 1) line.appendChild(el_('span', 'spn-posgrp__t', side[1]));
          var pills = el_('div', 'spn-pills');
          m.pos.filter(function (q) { return q.side === side[0]; }).forEach(function (q) {
            var extra = posCharge(q, lg.fin).price;
            var b = el_('button', 'spn-pill', esc(q.label) + (extra ? '<small>+' + eur(extra) + '</small>' : ''));
            b.type = 'button';
            var why = '';
            if (!allowed(q, lg.fin)) why = allowed(q, 'druck') ? 'Nur im Digitaldruck möglich' : (allowed(q, 'stick') ? 'Nur als Stick möglich' : 'Nicht möglich');
            else if (blocked(q.key, i)) why = 'Schon durch das andere Logo belegt';
            b.disabled = !!why; if (why) b.title = why;
            if (q.max) b.setAttribute('aria-description', q.max);
            b.setAttribute('aria-pressed', lg.pos === q.key ? 'true' : 'false');
            b.addEventListener('click', function () {
              var cd = el.spnCap && el.spnPosDefs && el.spnPosDefs[q.key], dw = cd && cd.cap ? cd.w : DEFW[q.key]; // SP-CAP
              if (!lg.wSet && lg.width !== '' && dw) lg.width = String(dw);
              lg.pos = q.key; buildLogos(); update();
            });
            pills.appendChild(b);
          });
          line.appendChild(pills);
          grp.appendChild(line);
        });
        r2.appendChild(grp);
        card.appendChild(r2);

        // Breite + Datei
        var r3 = el_('div', 'spn-lrow spn-lrow--split');
        var wbox = el_('div', 'spn-wbox');
        wbox.appendChild(el_('span', 'spn-label', 'Breite'));
        var inp = el_('span', 'spn-input spn-input--sm', '<input type="text" inputmode="decimal" aria-label="Logobreite Logo ' + (i + 1) + ' in cm"><span>cm</span>');
        var wi = inp.querySelector('input'); wi.value = lg.width;
        wi.addEventListener('input', function () { lg.width = wi.value.replace(/[^0-9.,]/g, ''); lg.wSet = true; if (wi.value !== lg.width) wi.value = lg.width; emit(); });
        wbox.appendChild(inp);
        wbox.appendChild(el_('span', 'spn-hint', p.max ? esc(p.max) : 'Höhe proportional'));
        r3.appendChild(wbox);

        var up = el_('label', 'spn-upl' + ((lg.file || lg.fileUrl) ? ' has-file' : ''));
        up.hidden = state.later;
        up.innerHTML = '<input type="file" accept=".pdf,.svg,.png,.jpg,.jpeg,.ai,.eps" hidden>' +
          '<span class="spn-upl__ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg></span>' +
          '<span class="spn-upl__txt"><strong></strong><span>PDF, SVG, AI oder PNG</span></span>';
        up.querySelector('strong').textContent = lg.file ? lg.file.name + ' ✓' : (lg.fileUrl ? (lg.fileName || nbT('Datei aus deiner Bestellung', 'File from your order')) + ' ✓' : 'Logo-Datei wählen');
        var fi = up.querySelector('input');
        function setFile(f) {
          if (!f) return;
          if (f.size > 20 * 1024 * 1024) { msg('Die Datei ist größer als 20 MB. Schick sie uns gern nach der Bestellung per E-Mail.', true); return; }
          lg.file = f; lg.fileUrl = ''; buildLogos(); update();
        }
        fi.addEventListener('change', function () { setFile(fi.files && fi.files[0]); });
        ['dragenter', 'dragover'].forEach(function (ev) { up.addEventListener(ev, function (e) { e.preventDefault(); up.classList.add('is-drag'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { up.addEventListener(ev, function (e) { e.preventDefault(); up.classList.remove('is-drag'); }); });
        up.addEventListener('drop', function (e) { setFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
        r3.appendChild(up);
        card.appendChild(r3);

        logosBox.appendChild(card);
      });

      addBtn.hidden = state.logos.length >= maxLogos;
      drawMarks();
    }

    function drawMarks() {
      var NS = 'http://www.w3.org/2000/svg';
      ['front', 'back'].forEach(function (side) {
        var g = el.querySelector('[data-spn-marks="' + side + '"]');
        if (!g) return;
        while (g.firstChild) g.removeChild(g.firstChild);
        state.logos.forEach(function (lg, i) {
          var p = posOf(lg.pos, i);
          if (!p || !p.mark || p.side !== side) return;
          var r = document.createElementNS(NS, 'rect');
          r.setAttribute('x', p.mark[0]); r.setAttribute('y', p.mark[1]); r.setAttribute('width', p.mark[2]); r.setAttribute('height', p.mark[3]);
          r.setAttribute('rx', 8); r.setAttribute('fill', MARK_COLORS[i]); r.setAttribute('stroke', '#111'); r.setAttribute('stroke-width', 5);
          g.appendChild(r);
          var t = document.createElementNS(NS, 'text');
          t.setAttribute('x', p.mark[0] + p.mark[2] / 2); t.setAttribute('y', p.mark[1] + p.mark[3] / 2 + 13);
          t.setAttribute('text-anchor', 'middle'); t.setAttribute('font-size', '38'); t.setAttribute('font-weight', '700'); t.setAttribute('fill', '#111');
          t.textContent = String(i + 1);
          g.appendChild(t);
        });
      });
    }

    addBtn.addEventListener('click', function () {
      if (state.logos.length >= maxLogos) return;
      var i = state.logos.length, f0 = firstFin(i);
      state.logos.push({ fin: f0, pos: firstFree(i, f0) || firstPos(i, f0), width: '', file: null });
      buildLogos(); update();
      var cards = logosBox.querySelectorAll('.spn-logo');
      if (cards[i]) cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    laterChk.addEventListener('change', function () {
      state.later = laterChk.checked;
      laterTxt.hidden = !state.later;
      buildLogos(); update();
    });

    /* ---------------- Rechnen ---------------- */
    function calc() {
      var pieces = 0, goods = 0, minPrice = null;
      state.sel.forEach(function (n) {
        var q = state.qty[n] || {};
        data.sizes.forEach(function (s) {
          var v = vmap[n + '|' + s];
          if (v && (minPrice === null || v.price < minPrice)) minPrice = v.price;
          var k = q[s] || 0;
          if (k && v) { pieces += k; goods += k * v.price; }
        });
      });
      if (minPrice === null) minPrice = Math.min.apply(null, data.variants.map(function (v) { return v.price; }));
      var perPiece = 0;
      state.logos.forEach(function (lg, i) { perPiece += logoCost(lg, i); });
      var sub = goods + pieces * perPiece;
      var cur = null, next = null;
      for (var i = 0; i < data.tiers.length; i++) { if (sub >= data.tiers[i].minCents) cur = data.tiers[i]; else { next = data.tiers[i]; break; } }
      var pct = cur ? cur.pct : 0;
      var disc = Math.round(sub * pct / 100);
      return { pieces: pieces, goods: goods, sub: sub, perPiece: perPiece, unitFrom: minPrice + perPiece, cur: cur, next: next, pct: pct, disc: disc, total: sub - disc };
    }

    function update() {
      var r = calc();
      var minQ = data.minQty || 0, minO = data.minOrderCents || 0;

      // Kopfpreis bleibt statisch (Textilpreis ohne Veredelung, siehe setHeadPrice)
      var ft = $('[data-spn-fintotal]');
      if (ft) ft.textContent = '+' + eur(r.perPiece) + ' (' + state.logos.length + (state.logos.length === 1 ? ' Logo)' : ' Logos)');

      // Zeilensummen
      $$('[data-spn-row]').forEach(function (row) {
        var n = row.getAttribute('data-spn-row'), q = state.qty[n] || {}, t = 0;
        Object.keys(q).forEach(function (s) { t += q[s] || 0; });
        row.querySelector('[data-spn-rowsum]').textContent = t + ' Stk.';
      });

      // Mindestmenge
      var note = $('[data-spn-minnote]');
      if (minQ > 0) {
        var ok = r.pieces >= minQ;
        note.classList.toggle('is-ok', ok);
        note.textContent = ok ? 'Mindestmenge erreicht – Farben und Größen frei kombinierbar.'
          : 'Noch ' + (minQ - r.pieces) + (minQ - r.pieces === 1 ? ' Teil' : ' Teile') + ' bis zur Mindestmenge von ' + minQ + ' Stück – Farben und Größen frei kombinierbar.';
      }

      // Fortschritt
      var title, right, sub, w;
      if (r.sub < minO) {
        title = 'Noch ' + eur(minO - r.sub) + ' bis zum Mindestbestellwert';
        right = Math.round(r.sub / minO * 100) + ' %';
        var t0 = data.tiers[0];
        sub = !t0 ? 'Danach versandkostenfrei.' : (t0.minCents <= minO ? 'Danach versandkostenfrei und ' + t0.pct + ' % Staffelrabatt.' : 'Danach versandkostenfrei · Staffelrabatt ab ' + (t0.minCents / 100).toLocaleString('de-DE') + ' € Bestellwert.');
        w = Math.max(2, r.sub / minO * 100);
      } else if (r.next) {
        title = 'Noch ' + eur(r.next.minCents - r.sub) + ' bis ' + r.next.pct + ' % Rabatt';
        right = r.pct ? r.pct + ' % aktiv' : '';
        sub = 'Mindestbestellwert erreicht · Versand kostenfrei.';
        var base = r.cur ? r.cur.minCents : minO;
        w = Math.max(2, (r.sub - base) / (r.next.minCents - base) * 100);
      } else {
        title = 'Höchste Staffel erreicht'; right = r.pct + ' % aktiv'; sub = 'Versand kostenfrei.'; w = 100;
      }
      $('[data-spn-progtitle]').textContent = title;
      $('[data-spn-progright]').textContent = right;
      $('[data-spn-progsub]').textContent = sub;
      $('[data-spn-progbar]').style.width = Math.min(100, w) + '%';

      // Staffel
      var tiersBox = $('[data-spn-tiers]');
      tiersBox.innerHTML = '';
      data.tiers.forEach(function (t) {
        var d = document.createElement('div');
        d.className = 'spn-tier' + (r.cur && r.cur.pct === t.pct ? ' is-on' : '');
        d.innerHTML = '<b>' + t.pct + ' %</b><span>ab ' + (t.minCents / 100).toLocaleString('de-DE') + ' €</span>';
        tiersBox.appendChild(d);
      });

      // Summen
      $('[data-spn-summeta]').textContent = r.pieces + ' Stk. · ' + state.sel.length + (state.sel.length === 1 ? ' Farbe' : ' Farben');
      $('[data-spn-l-qty]').textContent = r.pieces + ' Stk. inkl. Veredelung';
      $('[data-spn-l-sub]').textContent = eur(r.sub);
      $('[data-spn-l-disclabel]').textContent = 'Staffelrabatt ' + r.pct + ' %';
      $('[data-spn-l-disc]').textContent = r.disc ? '– ' + eur(r.disc) : eur(0);
      $('[data-spn-l-ship]').textContent = r.sub >= minO ? 'kostenfrei' : 'frei ab ' + eur(minO);
      $('[data-spn-l-total]').textContent = eur(r.total);

      // Mobile-Leiste
      var mt = $('[data-spn-mbar-total]'), ms = $('[data-spn-mbar-sub]'), mp = $('[data-spn-mbar-prog]');
      if (mt) mt.textContent = eur(r.total);
      if (ms) ms.textContent = r.pieces + ' Stk. · ' + (r.sub < minO ? 'noch ' + eur(minO - r.sub) + ' bis Mindestwert' : (r.pct ? r.pct + ' % Rabatt aktiv' : 'Mindestwert erreicht'));
      if (mp) mp.style.width = Math.min(100, minO ? r.sub / minO * 100 : 100) + '%';

      // Buttons
      var ready = r.pieces >= Math.max(1, minQ);
      $$('[data-spn-add]').forEach(function (b) { b.setAttribute('aria-disabled', ready ? 'false' : 'true'); });

      // Schritt-Status
      var steps = $$('.spn-step');
      if (steps[0]) steps[0].classList.toggle('is-done', state.sel.length > 0);
      if (steps[1]) steps[1].classList.toggle('is-done', ready);
      if (steps[2]) steps[2].classList.toggle('is-done', state.later || state.logos.every(function (lg) { return !!(lg.file || lg.fileUrl); }));
      emit();
      return r;
    }

    /* ---------------- Warenkorb ---------------- */
    var msgEl = $('[data-spn-msg]');
    function msg(t, err, html) {
      msgEl.classList.toggle('is-error', !!err);
      if (html) msgEl.innerHTML = t; else msgEl.textContent = t;
    }

    function addToCart() {
      if (state.busy) return;
      var r = update();
      var minQ = Math.max(1, data.minQty || 0);
      if (r.pieces < minQ) {
        msg('Bitte mindestens ' + minQ + ' Teile eintragen – Farben und Größen dürfen gemischt werden.', true);
        var s2 = $$('.spn-step')[1]; if (s2) s2.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var missing = -1;
      if (!state.later) state.logos.forEach(function (lg, i) { if (!lg.file && !lg.fileUrl && missing < 0) missing = i; });
      if (missing >= 0) {
        msg('Bitte lade die Datei für Logo ' + (missing + 1) + ' hoch oder hake „Logo-Dateien schicke ich nach der Bestellung“ an.', true);
        var s3 = $$('.spn-step')[2]; if (s3) s3.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var pid = genId();
      var props = {};
      state.logos.forEach(function (lg, i) {
        var n = (i + 1) + '. Logo ';
        props[n + 'Veredelung'] = finLabel(lg.fin);
        props[n + 'Position'] = posOf(lg.pos, i).label;
        props[n + 'Breite'] = lg.width ? lg.width.replace('.', ',') + ' cm' : 'nach Absprache';
        props[n + 'Datei'] = state.later ? 'folgt nach der Bestellung per E-Mail' : (lg.file ? lg.file.name : (lg.fileUrl || ''));
      });
      if (typeof el.spnExtraProps === 'function') { try { Object.assign(props, el.spnExtraProps(state) || {}); } catch (e) {} }
      props._sp_parent_id = pid;
      props._sp_role = 'main';
      if (state.reorder) props['Nachbestellung von'] = state.reorder; // SP-NACHBESTELLEN

      var items = [];
      state.sel.forEach(function (n) {
        var q = state.qty[n] || {};
        data.sizes.forEach(function (s) {
          var v = vmap[n + '|' + s], k = q[s] || 0;
          if (v && k > 0) items.push({ id: v.id, quantity: k, properties: Object.assign({}, props) });
        });
      });
      var chargeProps = { 'Gehört zu': data.title, '_sp_parent_id': pid, '_sp_role': 'charge' };
      state.logos.forEach(function (lg, i) {
        var t = techOf(lg, i), pc = posCharge(posOf(lg.pos, i), lg.fin);
        var cp = Object.assign({ 'Logo': String(i + 1) }, chargeProps);
        if (t.id) items.push({ id: t.id, quantity: r.pieces, properties: Object.assign({}, cp) });
        var pp = posOf(lg.pos, i); // SP-BRUSTMITTE: geliehene Aufpreis-Variante → echte Position als Property
        if (pc.id && pc.price) items.push({ id: pc.id, quantity: r.pieces, properties: Object.assign({}, cp, pp.via ? { 'Position': pp.label } : {}) });
      });

      // SP-HINWEIS (10.10.2026): Hinweis des Kunden nur am ersten Artikel, leer = keine Property
      var noteTa = $('[data-spn-msgtext]');
      var noteTxt = noteTa ? noteTa.value.trim().slice(0, 500) : '';
      if (noteTxt && items[0]) items[0].properties[noteTa.getAttribute('data-key') || 'Dein Hinweis'] = noteTxt;

      state.busy = true;
      $$('[data-spn-add]').forEach(function (b) { b.classList.add('is-loading'); });
      msg('Wird in den Warenkorb gelegt …');
      // SP-LOGO-PREVIEW: Vorschaubild (async) als zusätzliche Datei-Property am ersten Artikel
      var pv = (typeof el.spnPreviewFiles === 'function' && !el.classList.contains('spn-noprev')) ? el.spnPreviewFiles(state) : null;
      Promise.resolve(pv).catch(function () { return []; }).then(function (extra) {
      var files = state.later ? [] : state.logos.map(function (lg, i) { return { key: (i + 1) + '. Logo Datei', file: lg.file }; }).filter(function (f) { return f.file; });
      (extra || []).forEach(function (f) { if (f && f.key && f.file) files.push(f); });
      var req;
      if (files.length) {
        var fd = new FormData();
        items.forEach(function (it, i) {
          fd.append('items[' + i + '][id]', it.id);
          fd.append('items[' + i + '][quantity]', it.quantity);
          Object.keys(it.properties).forEach(function (key) {
            if (i === 0 && files.some(function (f) { return f.key === key; })) return;
            fd.append('items[' + i + '][properties][' + key + ']', it.properties[key]);
          });
        });
        files.forEach(function (f) { fd.append('items[0][properties][' + f.key + ']', f.file, f.file.name); });
        req = { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd };
      } else {
        req = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) };
      }
      return fetch(root() + 'cart/add.js', req);
      })
        .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || 'Fehler beim Hinzufügen');
          msg('Im Warenkorb: ' + r.pieces + ' Stk. · <a href="' + root() + 'cart">Zum Warenkorb</a>' + nbAfter(), false, true);
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } catch (e) {}
        })
        .catch(function (err) { msg(err.message || 'Das hat nicht geklappt. Bitte versuche es erneut.', true); })
        .then(function () {
          state.busy = false;
          $$('[data-spn-add]').forEach(function (b) { b.classList.remove('is-loading'); });
        });
    }
    $$('[data-spn-add]').forEach(function (b) { b.addEventListener('click', addToCart); });
    (function () { // SP-HINWEIS: Zeichenzähler
      var ta = $('[data-spn-msgtext]'), cnt = $('[data-spn-msgcount]');
      if (!ta || !cnt) return;
      var upd = function () { cnt.textContent = ta.value.length + ' / 500'; };
      ta.addEventListener('input', upd); upd();
    })();

    /* ---------------- Kopfpreis: günstigster Textilpreis mit höchster Staffel ---------------- */
    function setHeadPrice() {
      var minP = Math.min.apply(null, data.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; }));
      if (!isFinite(minP)) minP = Math.min.apply(null, data.variants.map(function (v) { return v.price; }));
      var top = null;
      data.tiers.forEach(function (t) { if (!top || t.pct > top.pct) top = t; });
      var t0 = mdl(0).tech;
      var techRows = (t0.druck ? '<span class="spn-pbox__row"><span>Digitaldruck</span><b>+<span class="transcy-money">' + eur(t0.druck.price) + '</span></b></span>' : '') +
        (t0.stick ? '<span class="spn-pbox__row"><span>Stick</span><b>+<span class="transcy-money">' + eur(t0.stick.price) + '</span></b></span>' : '');
      // Box schon da (aus der Section oder erster Aufruf): nur die Veredelungspreise tauschen (z. B. nach Aris)
      var oldSide = el.querySelector('.spn-pbox .spn-pbox__side');
      if (oldSide) { oldSide.innerHTML = '<span class="spn-pbox__k">Veredelung je Stück</span>' + techRows; return; }
      var priceRow = $('.spn-price'), note = $('[data-spn-unit-note]');
      if (!priceRow) return;
      var dl = el.querySelector('.spn-process__head .spn-muted');
      var hasTop = top && top.pct > 0;
      var from = hasTop ? Math.round(minP * (100 - top.pct) / 100) : minP;
      var box = document.createElement('div');
      box.className = 'spn-pbox';
      box.innerHTML =
        '<div class="spn-pbox__main">' +
          '<span class="spn-pbox__k">Textil ohne Veredelung</span>' +
          '<span class="spn-pbox__v"><small>ab</small> ' + eur(from) + '<small> / Stk.</small></span>' +
          (hasTop ? '<span class="spn-pbox__c">mit ' + top.pct + ' % Staffelrabatt ab ' + (top.minCents / 100).toLocaleString('de-DE') + ' € Bestellwert</span>' : '') +
        '</div>' +
        '<div class="spn-pbox__side">' +
          '<span class="spn-pbox__k">Veredelung je Stück</span>' +
          techRows +
        '</div>' +
        '<div class="spn-pbox__foot">' + (hasTop ? 'Ohne Rabatt ab ' + eur(minP) + ' · ' : '') + 'inkl. MwSt., zzgl. Versand' + (dl && dl.textContent.trim() ? ' · ' + dl.textContent.trim() : '') + '</div>';
      priceRow.parentNode.insertBefore(box, priceRow);
      priceRow.hidden = true;
      if (note) note.hidden = true;
    }

    /* ---------------- Start ---------------- */
    setHeadPrice();
    buildLogos();
    syncSwatches();
    buildRows();
    if (state.active) showColor(state.active);
    arisWatch();
  }

  function boot() { document.querySelectorAll('[data-spn-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
